export const isWindows = 'userAgentData' in navigator && (navigator.userAgentData as any).platform == 'Windows';